import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DefaultDateTimeBehavior } from "./DefaultDateTimeBehavior";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

/** HIS項目入院日（入院情報）を生成する */
export class EnterHospDateBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "ENTER_HOSP_DATE";
  private static readonly EnterHospDateTimeKey = "ENTER_HOSP_DATE_TIME";

  constructor(private _defaultDateFormat?: string) {}
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === EnterHospDateBehavior.Key).map(x => x.value);
    const dateValues = itemValues
      .filter(x => !DateTimeStringUtility.isEmptyDate(x))
      .filter(x => DateTimeStringUtility.isDateFormat(x))
      .map(x => DateTimeStringUtility.toDateValue(x));
    const behavior = new DefaultDateTimeBehavior(EnterHospDateBehavior.EnterHospDateTimeKey);
    const hisInfoValue = behavior.getValue(hisInfoItems);
    const values = (hisInfoValue instanceof HisInformationDateTimeValue)
      ? hisInfoValue.data.map(convertToYMDDate)
      : [];
    const data = itemValues.length > 0 ? dateValues : values;
    return new HisInformationDateTimeValue(EnterHospDateBehavior.Key, data, this._defaultDateFormat);
  }
}

function convertToYMDDate(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
}
